import React from "react"

const ContentContainer = ({ children }) => (
  <div className="px-4 pb-8 bg-beige print:bg-transparent print:p-0">
    <div className="max-w-4xl mx-auto">{children}</div>
  </div>
)

export default ContentContainer
